import React from 'react';
import './Datasecurity.css';
import Header from './Header';
import Footer from './Footer';

const Datasecurity = () => {
    return (
        <div>
            <Header />
            <div className="nd-security-page">
                <div className="nd-security-container container">
                    <div className="nd-security-hero">
                        <div className="nd-security-badge">Information Security & Compliance</div>
                        <h1 className="nd-security-title">Data Security</h1>
                    </div>

                    <div className="nd-security-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-security-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">01</span>
                                <h5><strong>1. Our Commitment to Data Security</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <p>At N D Techland Private Limited, we take the security of your data seriously. We are committed to protecting your information from unauthorized access, disclosure, alteration, and destruction.</p>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-security-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">02</span>
                                <h5><strong>2. Security Measures</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <div className="nd-security-grid">
                                    <div className="nd-security-grid-item">
                                        <h6><b>Encryption</b></h6>
                                        <p>We use encryption protocols to protect your data during transmission and storage.</p>
                                    </div>
                                    <div className="nd-security-grid-item">
                                        <h6><b>Access Controls</b></h6>
                                        <p>We implement strict access controls to ensure that only authorized personnel can access your data.</p>
                                    </div>
                                    <div className="nd-security-grid-item">
                                        <h6><b>Regular Audits</b></h6>
                                        <p>We conduct regular security audits and assessments to identify and address potential vulnerabilities.</p>
                                    </div>
                                    <div className="nd-security-grid-item">
                                        <h6><b>Data Backup</b></h6>
                                        <p>We perform regular data backups to ensure that your information is not lost in case of a system failure or other unforeseen events.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-security-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">03</span>
                                <h5><strong>3. Your Role in Data Security</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <p>While we do our best to protect your data, it’s important that you also take steps to ensure your security. This includes using strong passwords, keeping your login credentials confidential, and being cautious when sharing personal information online.</p>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="nd-security-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">04</span>
                                <h5><strong>4. Data Breach Response</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <p>In the unlikely event of a data breach, we have a response plan in place to address the issue promptly. We will notify affected users as required by law and take appropriate steps to mitigate the impact.</p>
                            </div>
                        </div>

                        {/* Section 5 */}
                        <div className="nd-security-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">05</span>
                                <h5><strong>5. Compliance with Regulations</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <p>We comply with all applicable data protection laws and regulations, including the General Data Protection Regulation (GDPR) for users in the European Union. We ensure that your rights are respected and your data is handled in accordance with legal requirements.</p>
                            </div>
                        </div>

                        {/* Section 6 */}
                        <div className="nd-security-card nd-security-contact-card">
                            <div className="nd-security-card-header">
                                <span className="nd-security-num">06</span>
                                <h5><strong>6. Contact Us</strong></h5>
                            </div>
                            <div className="nd-security-card-body">
                                <p>If you have any questions or concerns about data security, please contact our Data Protection Officer at <a href="mailto:support@ndtechland.com">support@ndtechland.com</a>. We are here to help and ensure that your data remains secure.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Datasecurity;
